// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC9Os0uarImV7RecVG9aLBKe5iG5-_ZMDE",
  authDomain: "support-for-supports.firebaseapp.com",
  databaseURL: "https://support-for-supports-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "support-for-supports",
  storageBucket: "support-for-supports.firebasestorage.app",
  messagingSenderId: "8288696405",
  appId: "1:8288696405:web:42cb7934d7433fa9e47cdc",
  measurementId: "G-TM8H0PBSEL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
